import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router'
export default function LoginView() {

    const navigate = useNavigate()
    const [state, setState] = useState({
        user: 'admin',
        password: 'yelmo123!',
        error: ''
    
    })

    const login = async () => {
        
        let _user = process.env.REACT_APP_USER;
        let _pass = process.env.REACT_APP_PASS;

        if(state.user === _user && state.password === _pass){
            navigate('/home')
        }else{
            state.error = 'Usuario o contraseña incorrecta'
            setState({...state})
        }
    }

  return (
    <div className='login-view'>
        <div className='login-view-bg'></div>
        <div className='login-view-form'>
            <div className='text-red'>{state.error}</div>
            <div className='text-white'>Login</div>
            <div className='bold text-white f-34'>Crea dinámicas</div>
            <div className='text-white f-14'>Inicia sesión para empezar a crear</div>
            <input className='form-control mt-2' value={state.user} onChange={(evt)=>{
                state.user = evt.currentTarget.value
                setState({...state})
            }}></input>
                    <input className='form-control mt-2' value={state.password} onChange={(evt)=>{
                state.password = evt.currentTarget.value
                setState({...state})
            }}></input>
            <div className='mt-3'></div>
            <Button variant="primary" onClick={() => {
                login()
            }}>
                Ingresar
            </Button>

        </div>
    </div>
  )
}
